import { render } from "./MyNavMenu.vue?vue&type=template&id=33803ef0&scoped=true"
import script from "./MyNavMenu.vue?vue&type=script&lang=js"
export * from "./MyNavMenu.vue?vue&type=script&lang=js"

import "./MyNavMenu.vue?vue&type=style&index=0&id=33803ef0&scoped=true&lang=css"

import exportComponent from "/var/www/dashboard.epsasport-dev.apps.lu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33803ef0"]])

export default __exports__